// theme/assets/vavci-pdp-gallery.js
// VAVCI · PDP galería: miniaturas + sincronización del carrusel de la página.
// Incluye el lightbox a pantalla completa (abrir/navegar/cerrar, teclado, índice compartido).
// Módulo autónomo (type="module"): se ejecuta tras el parseo del DOM.
(function () {
  var root = document.querySelector('[data-vc-pdp]');
  if (!root) return;

  var track = root.querySelector('[data-vc-track]');
  var thumbs = root.querySelectorAll('[data-vc-thumb]');
  var INK = (getComputedStyle(document.documentElement).getPropertyValue('--vc-ink') || '').trim() || '#16110D';

  // Índice activo, compartido con el lightbox (tarea posterior).
  var current = 0;

  // Solo puede sonar un medio a la vez. Cualquier cambio de diapositiva —en la
  // ficha o en el lightbox— y la apertura/cierre del lightbox pasan por aquí.
  function pauseAllMedia(keep) {
    root.querySelectorAll('video').forEach(function (v) {
      if (v !== keep && !v.paused) {
        v.pause();
        var btn = v.parentElement && v.parentElement.querySelector('[data-vc-play]');
        if (btn) btn.hidden = false;
      }
    });
  }

  function setActiveThumb(i) {
    thumbs.forEach(function (b) {
      b.style.borderColor = (+b.getAttribute('data-vc-thumb') === i) ? INK : 'rgba(22,17,13,.12)';
    });
    keepThumbVisible(i);
  }

  function goToPage(i, smooth) {
    if (!track) return;
    pauseAllMedia(null);
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  }

  // isPlayable/syncZoomHint viven aquí, al nivel de la IIFE, a propósito: las llama
  // tanto el manejador de scroll de más abajo como el clic del lightbox (bloque
  // `if (box && track)`, mucho más abajo). Una function declaration dentro de un
  // bloque queda anclada a ESE bloque en modo estricto (este script es
  // type="module", siempre estricto) — declararlas aquí, junto a goToPage y
  // setActiveThumb, es lo que las hace visibles desde cualquier otro bloque sin
  // depender de que el minificador de Shopify genere alias var por su cuenta.
  var slides = track ? track.querySelectorAll('[data-media-id]') : [];
  var zoomHint = root.querySelector('.vc-pdp__zoomhint');

  // La diapositiva de un medio reproducible no se amplía: ahí el clic sirve para
  // reproducir. isPlayable es la única fuente de verdad de esa distinción.
  // Lista blanca a propósito (NO "distinto de imagen"): un media_type que no
  // sepamos reproducir (p.ej. external_video, un vídeo de YouTube/Vimeo incrustado)
  // tiene que seguir cayendo en el comportamiento de hoy — foto ampliable —, no
  // quedarse muerto sin lupa y sin botón ▶.
  function isPlayable(i) {
    var el = slides[i];
    if (!el) return false;
    var type = el.getAttribute('data-vc-media-type');
    return type === 'video' || type === 'model';
  }

  // La lupa y el cursor zoom-in solo tienen sentido sobre una imagen.
  function syncZoomHint() {
    if (!track) return;
    var playable = isPlayable(current);
    if (zoomHint) zoomHint.style.display = playable ? 'none' : 'flex';
    track.style.cursor = playable ? 'default' : 'zoom-in';
  }

  if (track) {
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = +btn.getAttribute('data-vc-thumb');
        current = i;
        goToPage(i, true);
        setActiveThumb(i);
      });
    });
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        if (track.clientWidth) {
          var next = Math.round(track.scrollLeft / track.clientWidth);
          if (next !== current) pauseAllMedia(null); // solo al cambiar de verdad de diapositiva
          current = next;
          setActiveThumb(current);
          syncZoomHint();
        }
      });
    }, { passive: true });
  }

  // ── Desbordamiento de la columna/tira de miniaturas: flechas + degradados ──
  // Solo existe el scroller si hay 2+ imágenes; con 1 no se renderizan miniaturas
  // y todo esto queda en no-op.
  var thumbsBox = root.querySelector('[data-vc-thumbs]');
  var thumbArrowUp = root.querySelector('[data-vc-thumbs-arrow="up"]');
  var thumbArrowDown = root.querySelector('[data-vc-thumbs-arrow="down"]');
  var thumbFadeUp = root.querySelector('[data-vc-thumbs-fade="up"]');
  var thumbFadeDown = root.querySelector('[data-vc-thumbs-fade="down"]');
  var thumbFadeLeft = root.querySelector('[data-vc-thumbs-fade="left"]');
  var thumbFadeRight = root.querySelector('[data-vc-thumbs-fade="right"]');
  // Umbral: el redondeo a subpíxel hace que scrollTop no llegue exacto al tope
  // y sin margen las pistas parpadearían en el extremo.
  var THUMB_EDGE = 2;
  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Eje que desborda ahora mismo: vertical (columna desktop) u horizontal (tira móvil).
  // Se detecta en caliente porque un resize cambia la maquetación sin recargar.
  function thumbsAxis() {
    if (!thumbsBox) return null;
    if (thumbsBox.scrollHeight - thumbsBox.clientHeight > THUMB_EDGE) return 'y';
    if (thumbsBox.scrollWidth - thumbsBox.clientWidth > THUMB_EDGE) return 'x';
    return null; // sin desbordamiento (pocas imágenes): ni flechas ni degradados
  }

  function setThumbHint(el, on) {
    if (el) el.classList[on ? 'add' : 'remove']('is-on');
  }

  function updateThumbHints() {
    if (!thumbsBox) return;
    var axis = thumbsAxis();
    var canUp = axis === 'y' && thumbsBox.scrollTop > THUMB_EDGE;
    var canDown = axis === 'y' && thumbsBox.scrollTop < thumbsBox.scrollHeight - thumbsBox.clientHeight - THUMB_EDGE;
    var canLeft = axis === 'x' && thumbsBox.scrollLeft > THUMB_EDGE;
    var canRight = axis === 'x' && thumbsBox.scrollLeft < thumbsBox.scrollWidth - thumbsBox.clientWidth - THUMB_EDGE;
    // Las flechas son las MISMAS en ambos ejes: en columna señalan ↑/↓ y en la
    // tira móvil el CSS las rota a ◀/▶, así que "up" también responde a canLeft
    // y "down" a canRight (los ejes son excluyentes, nunca se mezclan estados).
    setThumbHint(thumbArrowUp, canUp || canLeft);
    setThumbHint(thumbFadeUp, canUp);
    setThumbHint(thumbArrowDown, canDown || canRight);
    setThumbHint(thumbFadeDown, canDown);
    setThumbHint(thumbFadeLeft, canLeft);
    setThumbHint(thumbFadeRight, canRight);
  }

  // Mantiene la miniatura activa a la vista moviendo SOLO el scroll interno del
  // scroller. Nada de scrollIntoView: la galería es sticky y desplazaría la
  // página entera al sincronizar con el swipe del carrusel.
  function keepThumbVisible(i) {
    if (!thumbsBox || !thumbs.length) return;
    var btn = thumbs[i];
    if (!btn) return;
    var axis = thumbsAxis();
    var PAD = 6; // aire para que la activa no quede pegada bajo flecha/degradado
    var behavior = REDUCED_MOTION ? 'auto' : 'smooth';
    if (axis === 'y') {
      // offsetTop es posición de maquetación (no cambia con el scroll), relativa
      // al ancestro posicionado: el propio scroller (absolute) o su wrapper
      // (relative), que coinciden en origen.
      if (btn.offsetTop < thumbsBox.scrollTop + PAD) {
        thumbsBox.scrollTo({ top: btn.offsetTop - PAD, behavior: behavior });
      } else if (btn.offsetTop + btn.offsetHeight > thumbsBox.scrollTop + thumbsBox.clientHeight - PAD) {
        thumbsBox.scrollTo({ top: btn.offsetTop + btn.offsetHeight - thumbsBox.clientHeight + PAD, behavior: behavior });
      }
    } else if (axis === 'x') {
      if (btn.offsetLeft < thumbsBox.scrollLeft + PAD) {
        thumbsBox.scrollTo({ left: btn.offsetLeft - PAD, behavior: behavior });
      } else if (btn.offsetLeft + btn.offsetWidth > thumbsBox.scrollLeft + thumbsBox.clientWidth - PAD) {
        thumbsBox.scrollTo({ left: btn.offsetLeft + btn.offsetWidth - thumbsBox.clientWidth + PAD, behavior: behavior });
      }
    }
  }

  if (thumbsBox) {
    // Flechas: avanzan ~2 miniaturas en el eje que desborde. La unidad usa la
    // medida real de una miniatura más el gap CSS de cada maquetación (14px en
    // la columna desktop, 10px en la tira móvil).
    var stepThumbs = function (dir) {
      var behavior = REDUCED_MOTION ? 'auto' : 'smooth';
      if (thumbsAxis() === 'x') {
        var unitX = thumbs.length ? thumbs[0].offsetWidth + 10 : thumbsBox.clientWidth / 2;
        thumbsBox.scrollBy({ left: dir * unitX * 2, behavior: behavior });
      } else {
        var unitY = thumbs.length ? thumbs[0].offsetHeight + 14 : thumbsBox.clientHeight / 2;
        thumbsBox.scrollBy({ top: dir * unitY * 2, behavior: behavior });
      }
    };
    if (thumbArrowUp) thumbArrowUp.addEventListener('click', function () { stepThumbs(-1); });
    if (thumbArrowDown) thumbArrowDown.addEventListener('click', function () { stepThumbs(1); });

    // Recalcular pistas al scrollear (con rAF, como el track) y al redimensionar
    // (el eje puede cambiar entre columna y tira al cruzar los 900px).
    var thumbsRaf;
    var queueThumbHints = function () {
      if (thumbsRaf) return;
      thumbsRaf = requestAnimationFrame(function () {
        thumbsRaf = null;
        updateThumbHints();
      });
    };
    thumbsBox.addEventListener('scroll', queueThumbHints, { passive: true });
    window.addEventListener('resize', queueThumbHints, { passive: true });
    updateThumbHints();
  }

  // ── Sincronización con el selector de formato (variantes) ──
  // El selector lo pinta la sección y solo conoce el ID del medio de cada variante;
  // la correspondencia id → posición vive aquí, que es donde está la galería. Va
  // DESPUÉS del bloque de miniaturas a propósito: setActiveThumb necesita thumbsBox
  // ya resuelto para poder traer la miniatura activa a la vista.
  if (track) {
    // ── Medios reproducibles (vídeo / 3D) ──
    root.querySelectorAll('[data-vc-play]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        // Sin esto, el mismo clic abriría el lightbox encima del vídeo: el
        // carrusel entero escucha clics para ampliar (ver más abajo).
        e.stopPropagation();
        var slide = btn.closest('[data-media-id]') || btn.closest('.vc-lb__slide');
        // 3D: revelar el visor de Shopify. La librería solo existe en fichas con modelo.
        var model = slide && slide.querySelector('model-viewer');
        if (model) {
          // El botón solo se oculta si la activación tuvo éxito de verdad. Si el
          // <script defer> de la librería 3D todavía no se ha ejecutado (conexión
          // lenta, clic muy temprano), ninguna guarda de aquí abajo salta: ocultar
          // el botón sin más dejaría un póster muerto y sin forma de reintentar
          // (el vídeo no tiene este problema porque le quedan los controles nativos).
          if (window.Shopify && window.Shopify.ModelViewerUI && !model.dataset.vcReady) {
            new window.Shopify.ModelViewerUI(model);
            model.dataset.vcReady = '1';
          }
          if (typeof model.dismissPoster === 'function') {
            model.dismissPoster();
            btn.hidden = true;
          }
          return;
        }
        var video = slide && slide.querySelector('video');
        if (!video) return;
        // playsinline: sin él, iOS secuestra el vídeo al reproductor del sistema.
        video.setAttribute('playsinline', '');
        // El ▶ ya NO se oculta aquí a mano: lo hace el listener de 'play' del
        // propio <video> (más abajo), que manda porque también hay que ocultarlo
        // cuando la reproducción arranca desde los controles nativos y no desde
        // este botón. Como el botón nunca queda oculto de antemano, si play()
        // rechaza la promesa (política de autoplay sin gesto suficiente, etc.) no
        // hay nada que restituir; el catch solo evita que quede como rechazo sin
        // capturar en consola.
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });
    });

    // El estado del ▶ superpuesto lo manda el propio <video>, no quien lo
    // arrancó: los controles nativos (controls:true en el media_tag) también
    // pueden reproducirlo, y si eso pasa nadie más se entera de ocultar el
    // botón. 'play' lo oculta pase lo que pase; 'ended' lo devuelve para poder
    // relanzar la reproducción. NO se escucha 'pause': el ▶ grande es la
    // invitación a EMPEZAR, no un conmutador de play/pausa —pausar/reanudar a
    // media reproducción es cosa de los controles nativos, que ya están ahí— y
    // devolverlo a mitad taparía el fotograma con un botón de 74px en cada
    // pausa. (El regreso al cambiar de diapositiva es un caso aparte: lo cubre
    // pauseAllMedia, más arriba, a propósito.)
    root.querySelectorAll('video').forEach(function (video) {
      var btn = video.parentElement && video.parentElement.querySelector('[data-vc-play]');
      if (!btn) return;
      video.addEventListener('play', function () { btn.hidden = true; });
      video.addEventListener('ended', function () { btn.hidden = false; });
    });

    function mediaIndex(id) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(id)) return i;
      }
      return -1;
    }

    // Deja la galería EXACTAMENTE como si se hubiera pulsado la miniatura i: misma
    // imagen, misma miniatura marcada y mismo índice para el lightbox. Reutiliza el
    // camino que ya existe en vez de duplicarlo.
    function showMedia(i, smooth) {
      current = i;
      goToPage(i, smooth);
      setActiveThumb(i);
      syncZoomHint();
    }

    root.addEventListener('vavci:show-media', function (e) {
      var id = e.detail && e.detail.id;
      if (!id) return;                 // variante sin imagen propia: no se toca la galería
      var i = mediaIndex(id);
      if (i < 0) return;               // el medio no está entre los de la galería: idem
      showMedia(i, true);
    });

    // Llegada directa con ?variant=… : Shopify ya deja esa variante seleccionada en
    // el servidor, así que la galería abre en SU imagen. Sin animación, porque es el
    // estado inicial y no un movimiento del visitante. Se espera a que el carrusel
    // tenga ancho — sin él scrollTo se quedaría en 0 — con el mismo reintento por
    // frame que usa el lightbox al abrirse.
    var start = +(track.getAttribute('data-vc-start') || 0);
    if (start > 0) {
      current = start;
      (function place(tries) {
        if (track.clientWidth) { showMedia(start, false); return; }
        if (tries < 20) requestAnimationFrame(function () { place(tries + 1); });
      })(0);
    }
    syncZoomHint();
  }

  // ── Lightbox a pantalla completa ──
  var box = root.querySelector('[data-vc-lightbox]');
  if (box && track) {
    var lbTrack = box.querySelector('[data-vc-lb-track]');
    var lbThumbs = box.querySelectorAll('[data-vc-lb-thumb]');
    var counterCur = box.querySelector('[data-vc-lb-cur]');
    var closeBtn = box.querySelector('[data-vc-lb-close]');
    var prevBtn = box.querySelector('[data-vc-lb-prev]');
    var nextBtn = box.querySelector('[data-vc-lb-next]');
    var count = lbTrack ? lbTrack.children.length : 0;

    function setActiveLb(i) {
      if (counterCur) counterCur.textContent = i + 1;
      lbThumbs.forEach(function (b) {
        b.style.borderColor = (+b.getAttribute('data-vc-lb-thumb') === i) ? '#fff' : 'rgba(255,255,255,.3)';
      });
    }
    function goToLb(i, smooth) {
      pauseAllMedia(null);
      i = Math.max(0, Math.min(count - 1, i));
      current = i;
      if (lbTrack) lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      setActiveLb(i);
    }

    function openLightbox() {
      pauseAllMedia(null);
      if (typeof box.showModal !== 'function') return; // navegador sin <dialog>: no-op (imagen ya visible)
      box.showModal();
      document.documentElement.style.overflow = 'hidden';
      // Coloca sin animación en la imagen activa, esperando a que el dialog tenga ancho
      // (evita saltar a la imagen 0 si clientWidth aún es 0 en el primer frame).
      var tries = 0;
      (function place() {
        if (lbTrack && lbTrack.clientWidth) { goToLb(current, false); return; }
        if (tries++ < 20) requestAnimationFrame(place);
      })();
    }

    // Cierre: botón, Esc (evento nativo 'close'), clic en el fondo.
    if (closeBtn) closeBtn.addEventListener('click', function () { box.close(); });
    box.addEventListener('close', function () {
      pauseAllMedia(null);
      document.documentElement.style.overflow = '';
      // Sincroniza la galería de la página con la última imagen vista.
      goToPage(current, false);
      setActiveThumb(current);
    });
    box.addEventListener('click', function (e) {
      if (e.target === box) box.close(); // clic en el propio <dialog> (fondo), no en sus hijos
    });

    // Navegación.
    if (prevBtn) prevBtn.addEventListener('click', function () { goToLb(current - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToLb(current + 1, true); });
    lbThumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { goToLb(+btn.getAttribute('data-vc-lb-thumb'), true); });
    });
    var lbRaf;
    if (lbTrack) lbTrack.addEventListener('scroll', function () {
      if (lbRaf) return;
      lbRaf = requestAnimationFrame(function () {
        lbRaf = null;
        if (lbTrack.clientWidth) {
          var nextLb = Math.round(lbTrack.scrollLeft / lbTrack.clientWidth);
          if (nextLb !== current) pauseAllMedia(null);
          current = nextLb;
          setActiveLb(current);
        }
      });
    }, { passive: true });
    box.addEventListener('keydown', function (e) {
      // Con el foco en los controles nativos de un <video>, ←/→ rebobinan; si el
      // lightbox interceptara la tecla aquí, cambiaría de diapositiva y de paso
      // pausaría el vídeo que el visitante está manejando. Se cede el paso cuando
      // el evento viene del propio <video>.
      if (e.target && e.target.tagName === 'VIDEO') return;
      if (e.key === 'ArrowRight') { e.preventDefault(); goToLb(current + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goToLb(current - 1, true); }
    });

    // Apertura por clic en la imagen de la página, distinguiendo clic de swipe.
    // (No se captura el puntero — ver nota del proyecto sobre setPointerCapture.)
    var downX = 0, downY = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; moved = false; }, { passive: true });
    track.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) moved = true;
    }, { passive: true });
    track.addEventListener('click', function () {
      if (isPlayable(current)) return; // vídeo/3D: el clic es para reproducir, no para ampliar
      if (moved) return; // fue arrastre/swipe: no abrir
      openLightbox();
    });
  }
})();
